// extracted by mini-css-extract-plugin
module.exports = {"cta":"_2ew-QFKK","customFont":"_3Od6L1r9"};